export const cleanChartData = (data) => {
  if (!data) {
    return [];
  }

  const seen = new Set();
  const cleanedData = data.filter(item => {
    const duplicateCheckKey = `${item.x}-${item.y}`;
    if (seen.has(duplicateCheckKey)) {
      return false;
    }

    seen.add(duplicateCheckKey);
    return true;
  });

  return cleanedData;
};
